export default "__VITE_ASSET__DzsM2iQ1__"